(() => {
  if (window.FPImageCreditsReady) return;
  window.FPImageCreditsReady = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-fp-image-credit-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.fpImageCreditOpen);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const closer = event.target.closest('[data-fp-image-credit-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      return;
    }

    if (event.target instanceof HTMLDialogElement) {
      const dialog = event.target;
      const box = dialog.getBoundingClientRect();
      const inside = (
        event.clientX >= box.left &&
        event.clientX <= box.right &&
        event.clientY >= box.top &&
        event.clientY <= box.bottom
      );
      if (!inside) dialog.close();
    }
  });
})();
